import { render, staticRenderFns } from "./NewSession.vue?vue&type=template&id=794b78e4&scoped=true"
import script from "./NewSession.vue?vue&type=script&lang=js"
export * from "./NewSession.vue?vue&type=script&lang=js"
import style0 from "./NewSession.vue?vue&type=style&index=0&id=794b78e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b78e4",
  null
  
)

export default component.exports